import { IDialogAction } from './IDialogAction';
import { DialogState } from '../models/DialogState';

export const ACTIVITY_ADDED = 'ACTIVITY_ADDED';

export class ActivityAddedAction implements IDialogAction {
    public readonly type = ACTIVITY_ADDED;
    public constructor(public payload: any) {}
    reducer(state: DialogState) {
        let tabId = this.payload.i;
        let messageId = this.payload.s;
        state.feed.tabs.filter(t => t.id == tabId).forEach(t => {
            if(!t.addedMessages.find(mId => mId === messageId)) {
                t.addedMessages.push(messageId);
                t.notification++;
            }
        });
        return state;
    }
}

export const ActivityAddedActionTypeMapping = {
    [ACTIVITY_ADDED]: ActivityAddedAction
};